<template>
    <v-list two-line>
        <v-row no-gutters>
            <v-col cols="12" lg="6" xl="4" class="application_list"
                   v-for="(application, index) in applications" :key="index">
                <application :application="application"></application>
            </v-col>
        </v-row>
    </v-list>
</template>

<script>
    import Application from "./Application";

    export default {
        name: "ApplicationList",
        components: { Application },
        props: {
            applications: Array
        },
    }
</script>

<style scoped>

</style>
